import styled from 'styled-components';
import {
  Modal,
  Loading,
  SectionHeading,
  PrimaryButton,
  SecondaryButton,
  ButtonContainer
} from '../atoms';

type TProcessingModal = {
  isModalOpen: boolean;
  handleModalClose: () => void;
  title: string;
  processing: boolean;
  processedMsg: string | null;
  confirmation?: boolean;
  confirmationMessage?: string | null;
  handleConfirmation?: () => void;
};

const FormFooter = styled((props) => <ButtonContainer {...props} />)`
  margin-top: 45px;
`;

const ProcessingModal = ({
  isModalOpen,
  handleModalClose,
  title,
  processing,
  processedMsg,
  confirmation,
  confirmationMessage,
  handleConfirmation
}: TProcessingModal) => {
  return (
    <Modal
      handleClose={handleModalClose}
      isModalVisible={isModalOpen}
      content={
        <>
          <SectionHeading>{title}</SectionHeading>
          {processing && <Loading />}
          {!processing && processedMsg && <p>{processedMsg}</p>}
          {confirmation && !processing && !processedMsg && (
            <>
              <p>{confirmationMessage}</p>

              <FormFooter
                horizontalSpacing="10px"
                verticalSpacing="0px"
                justify="end"
              >
                <SecondaryButton type="button" onClick={handleModalClose}>
                  Cancel
                </SecondaryButton>
                <PrimaryButton type="button" onClick={handleConfirmation}>
                  Continue
                </PrimaryButton>
              </FormFooter>
            </>
          )}
        </>
      }
    />
  );
};

export { ProcessingModal };
